export const SUPPORTED_MARKETS = [
  {
    marketId: '16',
    label: '上海指数',
  },
  {
    marketId: '17',
    label: '上海A股 & 沪伦通CDR',
  },
  {
    marketId: '18',
    label: '上海B股',
  },
  {
    marketId: '19',
    label: '上海债券(包含退市代码)',
  },
  {
    marketId: '20',
    label: '上海基金',
  },
  {
    marketId: '21',
    label: '退市整理',
  },
  {
    marketId: '22',
    label: '风险警示',
  },
  {
    marketId: '32',
    label: '深圳指数',
  },
  {
    marketId: '33',
    label: '深圳A股',
  },
  {
    marketId: '34',
    label: '深圳B股',
  },
  {
    marketId: '35',
    label: '深圳债券(包含退市代码)',
  },
  {
    marketId: '36',
    label: '深圳基金',
  },
  {
    marketId: '37',
    label: '退市整理',
  },
  {
    marketId: '48',
    label: '新同花顺指数',
  },
  {
    marketId: '49',
    label: '三级行业',
  },
];

export const SUPPORTED_MARKET_IDS = SUPPORTED_MARKETS.map(
  item => item.marketId
);
